import { render, staticRenderFns } from "./SemesterExam.vue?vue&type=template&id=b2b348e0&"
import script from "./SemesterExam.vue?vue&type=script&lang=js&"
export * from "./SemesterExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports